export class ModelBase extends Phaser.Events.EventEmitter {
  // requires an array of keys to serialize
  constructor(key = 'undefined', { serialize = [], colour = false } = {}) {
    super();
    this._logname = key;
    this._serializeKeys = serialize ? [...serialize] : [];
    this._enableLogs = true;
    this._colour = colour;
  }

  // save/load data
  serialize() {
    return ModelBase.SerializeObject(this, this._serializeKeys);
  }

  deserialize(data) {
    ModelBase.DeserializeObject(this, data, this._serializeKeys);
  }

  enableLogs(value) {
    this._enableLogs = value;
  }

  log(...args) {
    if (__DEBUG__ && this._enableLogs)
      console.log(
        '%c[' + this._logname + ']',
        this._colour ? 'color:' + this._colour : '',
        ...args
      );
  }

  dispatchUpdate() {
    this.emit('UPDATED', this);
  }
}

ModelBase.SerializeObject = (obj, keys) => {
  return keys.reduce((o, key) => {
    if (obj[key]?.serialize) {
      o[key] = obj[key].serialize();
    } else {
      o[key] = obj[key];
    }
    return o;
  }, {});
};

ModelBase.DeserializeObject = (obj, data, keys) => {
  keys.forEach((key) => {
    if (data.hasOwnProperty(key)) {
      if (obj[key]?.deserialize) {
        obj[key].deserialize(data[key]);
      } else {
        obj[key] = data[key];
      }
    }
  });
};
